import { render, staticRenderFns } from "./ManufacturersList.vue?vue&type=template&id=239d2b82&scoped=true&"
import script from "./ManufacturersList.vue?vue&type=script&lang=js&"
export * from "./ManufacturersList.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturersList.vue?vue&type=style&index=0&id=239d2b82&lang=scss&scoped=true&"
import style1 from "./ManufacturersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239d2b82",
  null
  
)

export default component.exports